import React from 'react';
import { formatCurrency, formatDate } from './SuperAdminShared';

const SuperAdminCompanies = ({ companies }) => (
  <section className="mt-6 space-y-6">
    <div className="rounded-lg bg-white shadow-sm">
      <div className="border-b px-5 py-4">
        <h3 className="text-lg font-semibold">Company subscriptions</h3>
        <p className="mt-1 text-sm text-slate-500">See who registered, which package they took, and how many admins/workers are active.</p>
      </div>
      <div className="overflow-x-auto">
        <table className="min-w-[1100px] w-full text-sm">
          <thead className="bg-slate-50 text-slate-500">
            <tr>
              <th className="px-4 py-3 text-left">Company</th>
              <th className="px-4 py-3 text-left">Owner</th>
              <th className="px-4 py-3 text-left">Email</th>
              <th className="px-4 py-3 text-left">Plan</th>
              <th className="px-4 py-3 text-left">Price</th>
              <th className="px-4 py-3 text-left">Registered</th>
              <th className="px-4 py-3 text-left">Valid Till</th>
              <th className="px-4 py-3 text-left">Status</th>
              <th className="px-4 py-3 text-left">Admins</th>
              <th className="px-4 py-3 text-left">Workers</th>
            </tr>
          </thead>
          <tbody>
            {companies.map((company) => (
              <tr key={company.id} className="border-t">
                <td className="px-4 py-3 font-medium">{company.company_name}</td>
                <td className="px-4 py-3">{company.owner_name}</td>
                <td className="px-4 py-3">{company.owner_email || '-'}</td>
                <td className="px-4 py-3">{company.package_name || '-'}</td>
                <td className="px-4 py-3">{formatCurrency(company.price)}</td>
                <td className="px-4 py-3">{formatDate(company.created_at)}</td>
                <td className="px-4 py-3">{formatDate(company.subscription_end_date)}</td>
                <td className="px-4 py-3">
                  <span className={`rounded-full px-2 py-1 text-xs ${company.subscription_status === 'active' ? 'bg-emerald-100 text-emerald-700' : 'bg-rose-100 text-rose-700'}`}>
                    {company.subscription_status || 'inactive'}
                  </span>
                </td>
                <td className="px-4 py-3">{company.admin_count || 0}</td>
                <td className="px-4 py-3">{company.worker_count || 0}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </section>
);

export default SuperAdminCompanies;
